/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResubmitApplication_reprocessCreditApplication_Status = { readonly __typename: 'Status', readonly message: string | null };

export type ResubmitApplication_Mutation = { readonly __typename: 'Mutation', readonly reprocessCreditApplication: ResubmitApplication_reprocessCreditApplication_Status | null };


export type ResubmitApplicationVariables = _Types.Exact<{
  salesforceCreditId: _Types.Scalars['String']['input'];
  reason: _Types.Scalars['String']['input'];
}>;


export type ResubmitApplication = ResubmitApplication_Mutation;


export const ResubmitApplicationDocument = gql`
    mutation ResubmitApplication($salesforceCreditId: String!, $reason: String!) {
  reprocessCreditApplication(
    salesforceCreditId: $salesforceCreditId
    reason: $reason
  ) {
    message
  }
}
    `;
export type ResubmitApplicationMutationFn = Apollo.MutationFunction<ResubmitApplication, ResubmitApplicationVariables>;

/**
 * __useResubmitApplication__
 *
 * To run a mutation, you first call `useResubmitApplication` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResubmitApplication` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resubmitApplication, { data, loading, error }] = useResubmitApplication({
 *   variables: {
 *      salesforceCreditId: // value for 'salesforceCreditId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useResubmitApplication(baseOptions?: Apollo.MutationHookOptions<ResubmitApplication, ResubmitApplicationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResubmitApplication, ResubmitApplicationVariables>(ResubmitApplicationDocument, options);
      }
export type ResubmitApplicationHookResult = ReturnType<typeof useResubmitApplication>;
export type ResubmitApplicationMutationResult = Apollo.MutationResult<ResubmitApplication>;
export type ResubmitApplicationMutationOptions = Apollo.BaseMutationOptions<ResubmitApplication, ResubmitApplicationVariables>;